export enum FieldType {
    TEXT = 'TEXT',
    TEXT_AREA = 'TEXT_AREA',
    NUMBER = 'NUMBER',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    SELECT = 'SELECT',
    DATE_PICKER = 'DATE_PICKER',
    TIME_PICKER = 'TIME_PICKER',
    SLIDER = 'SLIDER',
    CHECKBOX_GROUP = 'CHECKBOX_GROUP',
}

export type Validator = { regexp?: RegExp; messageError?: string }

type QuestionFieldTypeCommon = {
    fieldTypeId: FieldType.TEXT | FieldType.TEXT_AREA | FieldType.NUMBER
    value?: string | number
    validators?: Validator[]
}

export type Option = {
    label: string
    value: string | number
    suggest: string
    subOptions?: Option[]
    // valueUser?: string | number
}

export type SubOption = {
    label: string
    value: string | number
    suggest: string
}

export type QuestionFieldTypeWithOption = {
    fieldTypeId: FieldType.RADIO | FieldType.CHECKBOX | FieldType.SELECT | FieldType.CHECKBOX_GROUP
    value?: number | any
    options: Option[]
    calGrade: (number | undefined)[]
}
type QuestionFieldTypeDatePicker = {
    fieldTypeId: FieldType.DATE_PICKER
    value?: Date
    minDate?: Date
    maxDate?: Date
}
type QuestionFieldTypeTimePicker = {
    fieldTypeId: FieldType.TIME_PICKER
    value?: Date
}
type QuestionFieldTypeSlider = {
    fieldTypeId: FieldType.SLIDER
    value?: number
    marks: { [key: number]: string }
}
export type Question = {
    suggestion?: null | string
    id?: number | string
    label: string
    description?: string
    required?: boolean
    photo?: { url: string; description?: string; width: number; height: number; align: 'left' | 'right' | 'center' }
    video?: {
        url: string
        description?: string
        width: number
        height: number
        align: 'left' | 'right' | 'center'
        embed: 'youtube'
    }
    file?: string[] | undefined
    link?: string[] | undefined
    // subOptions? :  {id?: number | string ; value?: string  ;label?: string ;suggest? : string}[]
    answers?: string[] | undefined | string
} & (
    | QuestionFieldTypeCommon
    | QuestionFieldTypeWithOption
    | QuestionFieldTypeDatePicker
    | QuestionFieldTypeTimePicker
    | QuestionFieldTypeSlider
)

export type Purpose = {
    id?: number | string
    title: string
    description?: string
    questions: Question[]
}

export type Dimension = {
    id?: number | string
    title: string
    description?: string
    purposes: Purpose[]
}

export type Board = {
    nameID?: number | null
    name: string
    insID?: number | null
    ins: string
}

export type FormStructure = {
    title: string
    years?: number
    totalScore: number
    description?: string
    dimensions: Dimension[]
    board?: Board[]
}
